import React, { useState } from "react";
import classNames from "classnames";
import styles from "./CheckActions.module.css";
import PopupHeader from '../PopupHeader';
import FireboardUtils from "../../../../util/fireboard-util";
import strings from '../../../../globalization';

import cancel from "../../../../assets/images/Fireboard/action_buttons/cancel_white.png";
import done from "../../../../assets/images/Fireboard/action_buttons/done_white.png";
import inprogress from "../../../../assets/images/Fireboard/action_buttons/inprogress_white.png";
import joincheck from "../../../../assets/images/Fireboard/action_buttons/joincheck_white.png";
import location from "../../../../assets/images/Fireboard/action_buttons/location_white.png";
import markaspaid from "../../../../assets/images/Fireboard/action_buttons/markaspaid_white.png";
import markaspaidEuro from "../../../../assets/images/Fireboard/action_buttons/markaspaidEuro.png";
import preauth from "../../../../assets/images/Fireboard/action_buttons/preauth_white.png";
import scantopay from "../../../../assets/images/Fireboard/action_buttons/scantopay_white.png";
import sms from "../../../../assets/images/Fireboard/action_buttons/sms_white.png";
import sync from "../../../../assets/images/Fireboard/action_buttons/sync_white.png";
import texttopaydollar from "../../../../assets/images/Fireboard/action_buttons/texttopay_white.png";
import texttopayeuro from "../../../../assets/images/Fireboard/action_buttons/texttopayeuro_white.png";
import checkHistory from "../../../../assets/images/Fireboard/action_buttons/check_history.png";
import orderPrepared from '../../../../assets/images/Fireboard/being_prepared.png';
import orderReady from '../../../../assets/images/Fireboard/order_ready.png';
import redeemPoints from '../../../../assets/images/Fireboard/action_buttons/redeem_points.png';
import cubbyIcon from '../../../../assets/images/Fireboard/action_buttons/cubby_white.png';
import mapPinIcon from "../../../../assets/images/Fireboard/action_buttons/mappin_white.png";
import updatePhnNumIcon from "../../../../assets/images/Fireboard/action_buttons/update-phn-num-white.png";
import receiptWhiteIcon from "../../../../assets/images/Fireboard/action_buttons/receipt.png";

const col1Buttons = [
  {
    type: "done",
    icon: done,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as Done",
  },
  {
    type: "markAsSeeCounter",
    icon: done,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as See Counter",
  },
  {
    type: "markAsPickedUp",
    icon: done,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as Picked Up",
  },
  {
    type: "paid",
    icon: markaspaid,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as Paid",
  },
  {
    type: "moveToInprogress",
    icon: inprogress,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Move to Inprogress",
  },
  {
    type: "redeemVoucher",
    icon: redeemPoints,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Redeem Voucher",
  },
  {
    type: 'viewOnMap',
    icon: mapPinIcon,
    styles: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: 'View on map',
  },
  {
    type: "manageCubby",
    icon: cubbyIcon,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Manage Cubby",
  },
  {
    type: 'preAuth',
    icon: preauth,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Pre Auth",
  },
  {
    type: "cancel",
    icon: cancel,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Cancel Order",
  },
];

const col2Buttons = [
  {
    type: "sms",
    icon: sms,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Notify Guest",
  },
  {
    type: "updateGuestPhoneNumber",
    icon: updatePhnNumIcon,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Update Guest Phone Number",
  },
  {
    type: "orderBeingPrepared",
    icon: orderPrepared,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Notify Order Being Prepared",
  },
  {
    type: "orderReady",
    icon: orderReady,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Notify Order Ready",
  },
  {
    type: "checkIn",
    icon: location,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Text to Check In",
  },
  {
    type: "textToPay",
    icon: texttopaydollar,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Text to Pay",
  },
  {
    type: "qrscan",
    icon: scantopay,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Scan to Pay",
  },
  {
    type: "joinCheck",
    icon: joincheck,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Join Check",
  },
  {
    type: "resendReceipt",
    icon: receiptWhiteIcon,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Resend Receipt",
  },
  {
    type: "confirmIdCheck",
    icon: receiptWhiteIcon,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Confirm ID Check",
  },
  {
    type: "disableAgeRestricted",
    icon: receiptWhiteIcon,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Disable Age Restricted Items",
  },
];

const col3Buttons = [
  {
    type: "repostpayment",
    icon: checkHistory,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Re-Post Payment to POS",
  },
  {
    type: "resync",
    icon: sync,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Sync Check",
  },
];

export default function CheckActions(props) {
  const {
    updateOrderStatus,
    markItemAPaid,
    onQRGenerate,
    selectCheck,
    onHandleSms,
    onHandleTextToPay,
    textToCheckIn,
    selectedItem: item,
    onResyncCheck,
    managerMode,
    onPreAuth,
    dismissPopup,
    currency = '$',
    joinCheck,
    openPaymentHistory,
    notifyOrderReady,
    notifyOrderPrepared,
    notifyOrderStatus,
    onPressRedeemVoucher,
    onPressManageCubby,
    hideCubbyManager = false,
    enableGpsLocation,
    latitude,
    longitude,
    viewGuestLocationOnMap,
    onOpenUpdateGuestInformationModal,
    markAsSeeCounter,
    markOrderAsPickedUp,
    enabledMarkAsPickedUpOption,
    openResendReceiptPopup,
    enableResendReceipt,
    enableAgeVerification,
    markAsAgeVerified,
    enableAgeRestrictedOrderingForCheck,
    onUpdateAgeRestrictedItemsForCheck,
  } = props;

  const [selectedAction, setSelectedAction] = useState("");


  const displayPreAuth = item => {
    const { selectedCheckDetails } = item;
    const { tickets } = selectedCheckDetails || {};
    let showPreAuthIcon;
    if (!managerMode) return false;
    if (Array.isArray(tickets) && tickets.length) {
      tickets.forEach(ticket => {
        const { ticketStatusId, preAuth } = ticket || {};
        if (ticketStatusId === 0 && preAuth && item.unpaidAmount > 0) {
          showPreAuthIcon = true;
        }
      });
    } else {
      showPreAuthIcon = false;
    }
    return showPreAuthIcon;
  };

  const handleValidations = (type, item) => {
    const excludeCheck = item.orderStatusId !== 5 && item.orderStatusId !== 8;
    switch (type) {
      case "cancel":
        return excludeCheck;
      case "done":
        return (
          ((item.orderStatusId === 1 || item.orderStatusId === 0) && item.unpaidAmount === 0) ||
          item.orderStatusId === 5 ||
          item.orderStatusId === 8 ||
          item.orderStatusId === 9
        );
      case "sms":
        return true;
      case "qrscan":
        return item.unpaidAmount > 0 && excludeCheck;
      case "textToPay":
        return item.unpaidAmount > 0 && excludeCheck;
      case "checkIn":
        return excludeCheck;
      case "paid":
        return item.unpaidAmount > 0 && item.sourceType !== 0 && excludeCheck;
      case "resync":
        return true;
      case 'preAuth':
        return displayPreAuth(item) && excludeCheck;
      case "moveToInprogress":
        return item.orderStatusId === 0;
      case "joinCheck":
        return item.sourceType === 0 && item.open;
      case "repostpayment":
        return true;
      case 'orderBeingPrepared':
        return notifyOrderPrepared?.id ? true : false;
      case 'orderReady':
        return notifyOrderReady?.id ? true : false;
      case 'viewOnMap':
        const { orders } = item || {};
        return FireboardUtils.isViewOnMapOptionVisible(enableGpsLocation, latitude, longitude, orders);
      case 'redeemVoucher':
      case 'manageCubby':
        return true;
      case 'updateGuestPhoneNumber': {
        const { orders } = item || {};
        const [order0] = orders || [];
        const { memberId } = order0 || {};
        return !memberId;
      }
      case 'markAsSeeCounter':
        return true;
      case 'markAsPickedUp':
        return enabledMarkAsPickedUpOption || false;
      case 'resendReceipt': {
        const { tickets } = item || {};
        let hasSuccessTicket = false;
        if (tickets && Array.isArray(tickets))
          hasSuccessTicket = tickets.some(tk => tk.ticketStatusId === 1);
        return (enableResendReceipt && hasSuccessTicket);
      }
      case 'confirmIdCheck': {
        const { orders } = item || {};
        const [order0] = orders || [];
        const { ageVerificationStatus } = order0 || {};
        return enableAgeVerification && (ageVerificationStatus === 1 || ageVerificationStatus === 5);
      }
      case 'disableAgeRestricted': {
        return enableAgeRestrictedOrderingForCheck;
      }
      default:
        break;
    }
  };

  const handleActions = (type, item) => {
    switch (type) {
      case "cancel":
        updateOrderStatus(item, "cancel");
        break;
      case "done":
        updateOrderStatus(item, "done");
        break;
      case "sms":
        onHandleSms(item);
        selectCheck && selectCheck(item);
        break;
      case "qrscan":
        onQRGenerate(item);
        selectCheck && selectCheck(item);
        break;
      case "textToPay":
        onHandleTextToPay(item, false);
        break;
      case "checkIn":
        textToCheckIn(item, false);
        break;
      case "paid":
        markItemAPaid(item);
        break;
      case "resync":
        onResyncCheck(item);
        break;
      case "preAuth":
        onPreAuth(item);
        break;
      case "moveToInprogress":
        updateOrderStatus(item, "moveToInprogress");
        break;
      case "joinCheck":
        joinCheck(item);
        selectCheck && selectCheck(item);
        break;
      case "repostpayment":
        openPaymentHistory && openPaymentHistory();
        break;
      case 'orderBeingPrepared':
      case 'orderReady': notifyOrderStatus && notifyOrderStatus(type);
        break;
      case 'redeemVoucher':
        onPressRedeemVoucher && onPressRedeemVoucher();
        break;
      case 'manageCubby':
        onPressManageCubby && onPressManageCubby();
        break;
      case 'viewOnMap':
        viewGuestLocationOnMap && viewGuestLocationOnMap();
        break;
      case 'updateGuestPhoneNumber':
        onOpenUpdateGuestInformationModal && onOpenUpdateGuestInformationModal();
        break;
      case 'markAsSeeCounter':
        markAsSeeCounter && markAsSeeCounter();
        break;
      case 'markAsPickedUp':
        markOrderAsPickedUp && markOrderAsPickedUp();
        break;
      case 'resendReceipt':
        openResendReceiptPopup && openResendReceiptPopup();
        break;
      case 'confirmIdCheck':
        markAsAgeVerified && markAsAgeVerified();
        break;
      case 'disableAgeRestricted':
        onUpdateAgeRestrictedItemsForCheck && onUpdateAgeRestrictedItemsForCheck();
        break;
      default:
        break;
    }
  };

  const getCheckActionName = (action) => {
    if (action.type === 'disableAgeRestricted') {
      const { orders } = item || {};
      const [order0] = orders || [];
      const { disableAgeRestricted } = order0 || {};
      return disableAgeRestricted ? strings.enableAgeRestrictedItems : strings.disableAgeRestrictedItems;
    } else if (action.type === 'confirmIdCheck') {
      const { orders } = item || {};
      const [order0] = orders || [];
      const { ageVerificationStatus } = order0 || {};
      return ageVerificationStatus === 5 ? strings.clearIDCheck : strings.confirmIDCheck;
    } else {
      return action.name || '';
    }
  };

  const renderActionsButtons = (eachButton) => {
    const enabled = handleValidations(eachButton.type, item || {});
    let src = eachButton.icon;
    if (currency === '£' && eachButton.type === 'textToPay')
      src = texttopayeuro;
    if (currency === '£' && eachButton.type === 'paid')
      src = markaspaidEuro;
    return (
      <div
        key={eachButton.type}
        className={classNames({ [`${styles.innerContainer}`]: true, [`${styles.highligthtedAction}`]: selectedAction === eachButton.type, [styles.disabledButton]: !enabled })}
        onMouseEnter={() => setSelectedAction(eachButton.type)}
        onMouseLeave={() => setSelectedAction("")}
        onClick={() => enabled && handleActions(eachButton.type, item)}
      >
        <div className={styles.imgWrapper}>
          <img src={src} className={styles.icon} alt="icon" />
        </div>
        <span className={classNames({ [styles.buttonName]: true, [styles.disabledTxt]: !enabled })}>{getCheckActionName(eachButton)}</span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <PopupHeader title='' onClose={dismissPopup} containerStyle={styles.heading} />
      <div className={styles.buttonsContainer}>
        <div className={styles.column}>
          {col1Buttons.map((eachButton) =>
            eachButton.type === 'manageCubby'
              ? hideCubbyManager
                ? null
                : renderActionsButtons(eachButton)
              : renderActionsButtons(eachButton)
          )}
        </div>
        <div className={styles.column}>
          {col2Buttons.map((eachButton) =>
            renderActionsButtons(eachButton)
          )}
        </div>
        <div className={styles.column}>
          {col3Buttons.map((eachButton) =>
            renderActionsButtons(eachButton)
          )}
        </div>
      </div>
    </div>
  );
}
